<!-- 开户许可证 -->
<template>
  <div class="wrapper">
    <el-card class="mr_t">
      <div class="container">
        <div class="container_title">开户许可证</div>
        <el-form :model="form" :rules="rules" label-width="400px" ref="form">
          <el-form-item ref="accountOpeningFile" label="上传开户许可证" prop="accountOpeningFile">
            <el-upload class="upload-demo" action :on-preview="handlePreview" :on-remove="
                  (file, fileList) => {
                    handleRemove(file, fileList, 'accountOpeningFile');
                  }
                " :auto-upload="false" :on-change="
                  (file, fileList) => {
                    handleChange(file, fileList, 'accountOpeningFile');
                  }
                " :on-exceed="handleExceed" :file-list="accountOpeningFileList" accept=".jpg,.png">
              <div class="imgBox">
                <div class="imgBody" v-if="!addrList.accountOpeningFileAddr">
                  <i class="el-icon-plus"></i>
                  上传照片
                </div>
                <div class="imgfooter" v-if="addrList.accountOpeningFileAddr">
                  <img :src="khxkzUrl" alt="" width="100%" height="100%" />
                  <div class="imgTxt">
                    重新上传
                  </div>
                </div>
              </div>
              <div slot="tip" class="el-upload__tip el_upload_tips1">
                支持上传格式：.doc .docx .pdf .jpg .png <br />注：如无开户许可证，请按模版填写盖章后上传<br />
                <a @click="downLoadTpl('公司结算账户证明函（模板）.doc')" style="cursor: pointer;"><img src="@/assets/download2.png" class="download_img" align="absbottom">下载模版</a>
              </div>
            </el-upload>
          </el-form-item>
          <el-form-item label="银行名称" prop="bankName">
            <el-select placeholder="请输入银行名称" filterable remote :remote-method="remoteMethod" v-model="form.bankName" clearable :loading="loading" @change="bankNameChange">
              <el-option v-for="(item,index) in bankList" :key="index" :label="item.label" :value="item.label">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="银行账号" prop="bankAccount">
            <el-input placeholder="请输入银行账号" v-model="form.bankAccount" @blur="form.bankAccount = $event.target.value" oninput="value=value.replace(/[^0-9]/g,'')"></el-input>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="mr_t">
      <div class="btn">
        <el-button @click="save">保存</el-button>
        <el-button @click="jumpStep">上一步</el-button>
        <el-button type="primary" @click="submit">提交</el-button>
      </div>
    </el-card>
  </div>
</template>
<script>
import getMvcUrl from "../../../utils/mvcUrlUtil.js";
import { formatDate } from "@/common/js/date.js";
import { mapActions } from "vuex";
import { decrypt } from "@/api/util"
export default {
  data() {
    var _this = this;
    const getRule = (FileList, addrItem, text) => {
      return (rule, _value, callback) => {
        if (_this[FileList].length == "0" && !this.addrList[addrItem]) {
          return callback(new Error(text));
        } else {
          callback();
        }
      }
    }
    return {
      form: {
        customerNo: JSON.parse(sessionStorage.getItem("userInfo")).customerNo,
        customerName: "",
        address: "",
        creditCode: "",
        registerCapital: undefined,
        registerDate: "",
        registerDateStart: "",
        registerDateEnd: "",
        companyType: "",
        mentorName: "",
        corporaName: "",
        corporaIdNumber: "",
        corporaPhone: "",
        contactName: "",
        contactPhone: "",
        contractIdNumber: "",
        provinceCode: "",
        cityCode: "",
        bankName: "",
        banka: "",
        bankAccount: "",
        registerPersonFlag: "",
        provinceName: "",
        cityName: "",
        businessLicenseFileAddr: "",
        corporaFileAddress: "",
        idCarBFileAddr: "",
        attorneyFileAddress: "",
        mentorProveFileAddr: "",
        registerDatetype: "",
        accountOpeningFileAddr: "",
        corporaIdCarBFileAddr: "",
        contractFileAddress: ""
      },
      rules: {
        accountOpeningFile: [
          {
            required: true,
            validator: getRule('accountOpeningFileList', 'accountOpeningFileAddr', '请上传开户许可证'),
            trigger: "change",
          },
        ],
        bankName: [
          { required: true, message: "请输入开户银行名称", trigger: "blur" },
        ],
        bankAccount: [
          { required: true, message: "请输入开户银行账号", trigger: "blur" },
        ],
      },
      accountOpeningFileList: [],
      addrList: {
        businessLicenseFileAddr: "", //营业执照存储地址
        contractFileAddress: "", //联系人身份证件地址
        corporaIdCarBFileAddr: "", //联系人身份证件反面地址
        attorneyFileAddress: "", //委托书存储地址
        mentorProveFileAddr: "", //母公司证明材料
        accountOpeningFileAddr: "", //开户许可证文件
        corporaFileAddress: "", //法人身份证件地址
        idCarBFileAddr: "", //法人身份证件反面
      },
      loading: false,
      bankList: [],
      fileArr: [{ fileName: 'accountOpeningFile', listName: 'accountOpeningFileList' },],
      khxkzUrl: ""
    }
  },
  mounted() {
    this.formData = new window.FormData();
    this.imgBaseUrl = getMvcUrl() + "/saas/companyQualification/viewImage?objectName=";
    this.queryByCustomerNo();
  },
  methods: {
    ...mapActions([
      "queryBankAccountApi",
      "businessAuthenticationSubmitDraftForSaasApi",
      "businessAuthenticationForSaasApi",
      "queryByCustomerNoAPI",
    ]),
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) { },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    handleChange(file, fileList, val) {
      let size = Number(file.size / 1024 / 1024);
      let pass;
      if (size > 5) {
        this.$message.warning('文件大小不能超过5MB，请重新上传');
        pass = false;
      } else {
        pass = true;
      }
      this.fileArr.forEach(item => {
        if (item.fileName == val) {
          this[item.listName] = [];
          if (pass) {
            this[item.listName] = [];
            this[item.listName].push(file);
          } else {
            this.formData.delete(item.fileName);
          }
          this.formData.delete(item.fileName);
          this.formData.append(item.fileName, file.raw);
          if (item.type == 'idCard') {
            this.$refs.corporaFile.clearValidate();
          } else if (item.type == 'lxrCard') {
            this.$refs.contractFile.clearValidate();
          } else {
            this.$refs[item.fileName].clearValidate();
          }
        }
      })
    },
    handleRemove(file, fileList, val) {
      this.fileArr.forEach(item => {
        if (item.fileName == val) {
          this[item.listName] = [];
          this.formData.delete(item.fileName)
        }
      })
    },
    remoteMethod(val) {
      //console.log(val)
      if (val !== '') {
        this.loading = true;
        this.queryBankAccountApi({ bankName: val })
          .then(res => {
            if (res) {
              console.log(res)
              let result = res.bankList
              console.log(result);
              result = result.map(item => {
                return {
                  value: item.bankl,
                  label: item.banka,
                }
              })
              this.bankList = result.filter(item => {
                return item.label.toLowerCase()
                  .indexOf(val.toLowerCase()) > -1;
              });
              this.loading = false;
            }
          })
      } else {
        this.bankList = [];
      }
    },
    bankNameChange(val) {
      this.bankList.forEach(item => {
        if (val == item.label) {
          this.form.banka = item.value
        }
      })
    },
    downLoadTpl(tplName) {
      let preUrl = getMvcUrl() + '/saas/downLoad/downLoadTpl?tplName=' + tplName;
      window.open(preUrl);
    },
    jumpStep() {
      this.$emit("jumpStep", 1);
    },
    getParams() {
      let params = JSON.parse(JSON.stringify(this.form));
      return params;
    },
    save() {
      // 保存  提交草稿    
      let params = this.getParams(); 
      this.formData.delete("param");
      this.formData.append("param", JSON.stringify(params));
      //console.log(params)
      this.$nextTick(() => {
        this.businessAuthenticationSubmitDraftForSaasApi(this.formData).then((res) => {
          if (res) {
            this.$message.success("保存成功");
          }
        });
      });
    },
    queryByCustomerNo() {
      // 进入页面回显相关信息
      let params = {
        customerNo: this.form.customerNo,
      };
      this.queryByCustomerNoAPI(params).then((res) => {
        let { customerDetail, historyList } = res;
        //this.status = customerDetail.status;
        this.customerDetail = customerDetail;
        this.rejeactCause = historyList[0].updateResult;
        this.status = customerDetail.status;
        const decryptProps = []
        for (let key in this.form) {
          this.form[key] = customerDetail[key];
          if (customerDetail[`${key}Dto`]){
            decryptProps.push(key)
          }
        }
        for (let key in this.addrList) {
          this.addrList[key] = customerDetail[key];
          this.form[key] = customerDetail[key];
          if (customerDetail[`${key}Dto`]){
            decryptProps.push(key)
          }
        }

        let customerList = JSON.parse(window.sessionStorage.getItem('customerList'));
        if (customerDetail.mentorName) {
          let obj = customerList.find((item) => {
            return item.label == customerDetail.mentorName;
          });
          this.form.mentorName = obj.value;
        }
        decryptProps.forEach( async(prop) => {
          const decryptValue = await decrypt(customerDetail[`${prop}Dto`].encStr)
          this.form[prop] = decryptValue
        })
        
      });
      
    },
    submit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let params = this.getParams();
          //console.log(this.form, "提交")
          this.formData.delete("param");
          this.formData.append("param", JSON.stringify(params));
          //console.log(params)
          this.$nextTick(() => {
            this.businessAuthenticationForSaasApi(this.formData).then((res) => {
              if (res) {
                this.$message.success("提交成功");
                this.$emit("jumpStep", 3);//跳转审核
              }
            });
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    }
  }
}
</script>
<style lang="less" scoped>
/deep/ .el-form-item__content {
  width: 600px !important;
}
/deep/ .el-form-item {
  margin-bottom: 22px !important;
}
/deep/ .el-upload-list__item-name {
  width: 98px;
  margin-right: 0 !important;
}
/deep/ .el-date-editor.el-input,
.el-date-editor.el-input__inner,
.el-select,
/deep/ .el-input-number {
  width: 100% !important;
}
.wrapper {
  .mr_t {
    margin-top: 24px !important;
  }
  .container {
    padding: 24px 32px 200px 32px !important;
    .container_title {
      margin-bottom: 24px !important;
    }
    .imgBox {
      width: 80px;
      height: 80px;
      background: rgba(0, 0, 0, 0.02);
      border: 0.8px dashed rgba(0, 0, 0, 0.15);
      border-radius: 3px;
      position: relative;
      display: inline-block;
      .imgBody {
        width: 100%;
        height: 100%;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.65);
        line-height: 17.63px;
        font-weight: 400;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .el-icon-plus {
          width: 20px;
          height: 20px;
        }
      }
      .imgfooter {
        width: 100%;
        height: 100%;
        background-color: #f5f5f5;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .imgTxt {
          position: absolute;
          height: 30px;
          line-height: 30px;
          bottom: 0;
          left: 0;
          width: 100%;
          text-align: center;
          background: rgba(0, 0, 0, 0.5);
          color: #fff;
        }
      }
    }
    .el-upload__tip {
      line-height: 20px;
      margin-top: 20px !important;
      font-size: 12px;
      color: rgba(0, 0, 0, 0.45);
      font-weight: 400;
    }
    .el_upload_tips1 {
      position: absolute;
      top: 4px;
      left: 100px;
    }
  }
  .btn {
    padding: 24px 32px !important;
    text-align: right;
  }
  .imgWrapper {
    display: flex;
  }
  .download_img {
    width: 16px;
    height: 16px;
    margin-bottom: 2px !important;
  }
}
</style>